import { useMemo, useState, useEffect } from 'react';
import { Outlet,} from 'react-router-dom';
import { Layout, FloatButton, } from 'antd';
import { BaseHeader } from 'components/layouts/BaseHeader';
import { BaseSider } from 'components/layouts/BaseSider';
import { NavLayout } from './NavLayout';
import { BaseTabs } from 'components/containers';
import { useWindowDimensions } from 'hooks/useWindowDimensions';
import { BaseFooter } from './BaseFooter';

// eslint-disable-next-line no-unused-vars
const { Sider, Content, Footer } = Layout;

export const BaseLayout = ({ tabItems=[], defaultKey, header = true, sider = true, common, setCommon, children, sideHide=false }) => {
  const {width, height} = useWindowDimensions();
  const [isMenu, setIsMenu] = useState(true);
  const [breadItem,setBreadItem] = useState([]);
  const memoBreadIted = useMemo(()=>{
    return {breadItem,setBreadItem}
  },[,breadItem])
  

  return (
    <>
      <Layout>
        {header && <BaseHeader setMenu={setIsMenu} isMenu={isMenu} sideHide={sideHide} />}
        <Content style={{height: '100%'}}>
          <Layout className='layout-body'>
            <div className='side-container'>
                {sider && isMenu &&  <BaseSider common={common} setCommon={setCommon} />}
            </div>
            <Layout style={{display:'flex', flexDirection:'row', height:'auto'}}>
              <Content className='layout-content'>
                {
                  !sideHide && <>
                <NavLayout breadItem={breadItem}/>
                {tabItems?.length > 0 && <div className='layout-tab'><BaseTabs items={tabItems} defaultKey={defaultKey} /></div>}
                {tabItems?.length === 0 && (<div className='layout-section'>
                  <Outlet/>
                </div>)}
                </>
                }
                {children}
                <BaseFooter />
              </Content>
              <FloatButton.BackTop />
            </Layout>
            
          </Layout>        
        </Content>
        {/* <Footer
          style={{
            textAlign: 'center',
          }}
        >
        </Footer> */}
      </Layout>
    </>
  );
};
